/**
 * description 带字数统计的文本域
 * created by he.zhikai
 * created on 2018-04-16
 */
"use strict";
angular.module('util.trsWordCountTextareaSlot', []).directive('trsWordCountTextareaSlot', [function() {
    return {
        restrict: 'E',
        scope: {
            model: "=", //textarea框模型
            form: "=", //表单name
            name: "@", //textarea框name
        },
        transclude: true,
        templateUrl: "./components/util/trsWordCountTextarea/trsWordCountTextareaSlot_tpl.html",
        replace: true,
        link: function(scope, iElement, iAttrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                //textarea聚焦外层div高亮，textarea失焦外层div不亮
                iElement.find("textarea").bind("focus", function() {
                    iElement.addClass("focus");
                }).bind("blur", function() {
                    iElement.removeClass("focus");
                });
            }
        }
    };
}]);